/* eslint-disable @typescript-eslint/no-explicit-any */
import { Badge } from "@/components/ui/badge";

export const ReactTableCell = ({ header, value, roleList }: any) => {
  switch (header) {
    case "status": {
      return (
        <Badge variant={value ? "default" : "destructive"}>
          {value ? "Active" : "Inactive"}
        </Badge>
      );
    }
    case "role_id": {
      const current_role = roleList?.find(
        (item: any) => item?.role_id === value
      );
      return <span>{current_role?.role_name}</span>;
    }
    default: {
      return <span>{value}</span>;
    }
  }
};
